import { Plugin } from '../types/common';

const isDev = import.meta.env.MODE === 'development';

const syncPlugins: Plugin[] = [
];

const immediatePluginLoaders = {
  notification: () => import('./notification'),
};

const asyncPluginLoaders = {
    tableCorners:  () => import('./table'),
    carouselIntro: () => import('./carousel-intro'),
    carousel:      () => import('./carousel'),
    dropdown:      () => import('./dropdown'),
    header:        () => import('./header'),
    formBuilder:   () => import('./form-builder'),
    tabs:          () => import('./tabs'),
    accordion:     () => import('./accordion'),
    breadcrumbs:   () => import('./breadcrumbs'),
    gallery:       () => import('./gallery'),
    tooltip:       () => import('./tooltip'),
    rangeSlider:   () => import('./range-slider'),
    scrollbarWidth:() => import('./scrollbar-width'),
    anchors:       () => import('./anchors'),
    sheet:         () => import('./sheet'),
    tracking:      () => import('./tracking'),
    ...(isDev ? { customCss: () => import('./custom-css') } : {}),
    modal:              () => import('./modal'),
    datePickerSupport:  () => import('./support/date-picker-support'),
};

type PluginModule = Plugin | { default: Plugin };
type PluginLoader = () => Promise<PluginModule>;
type PluginLoaders = Record<string, PluginLoader>;

export async function loadAsyncPlugins(loaders: PluginLoaders){
    await Promise.all(
        Object.entries(loaders).map(async ([, loader]) => {
            try {
                const module = await loader();
                const plugin: Plugin = 'default' in module ? module.default : module;
                plugin.init();
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (error) {
                // NOTE: Ideally, report this error to Sentry or another error tracking service
            }
        })
    );
}

export function loadSyncPlugins(loaders: Plugin[]) {
    try {
        loaders.forEach(plugin => {
            if (plugin.init) {
                plugin.init();
            }
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        // NOTE: Ideally, report this error to Sentry or another error tracking service
    }
}

(async () => {
  await loadAsyncPlugins(immediatePluginLoaders);
})();

document.addEventListener('DOMContentLoaded', async () => {
    loadSyncPlugins(syncPlugins);

    await loadAsyncPlugins(asyncPluginLoaders);
});
